/**
 * **URL: `/g/$gardenToken` exactly** — a garden with no tab segment, which is the shape of
 * every shared link. It renders nothing: its whole job is to resolve that URL to a tab.
 *
 * The counterpart to `_app.index.tsx`, and deliberately the opposite in both respects:
 *
 * | | `_app.index.tsx` (`/`) | this file (`/g/$gardenToken`) |
 * |---|---|---|
 * | Target | the garden and tab you were last in | always the journal |
 * | Mechanism | a component rendering `<Navigate>` | `beforeLoad` redirect, no component |
 *
 * **Always the journal**, because a shared link must open the same page for every
 * recipient; personal history belongs at `/`, not on someone else's link.
 *
 * **`beforeLoad` rather than `<Navigate>`**, because it creates no history entry, so Back
 * moves past this URL instead of bouncing off it forever. It can be a loader here — unlike
 * at `/` — precisely because the target is a constant and needs no query to compute.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/g/$gardenToken/')({
  beforeLoad({ params }) {
    throw redirect({
      to: '/g/$gardenToken/journal',
      params,
      search: true,   // keep ?v= so deep links survive the redirect
      replace: true,
    });
  },
});
